import React, {useRef, useState, useEffect, useContext } from "react";
import { isEmpty } from "../../helpers/utils";
import styles from './YoutubeImageEmbed.module.css'
import {getSessionToken} from '@futures-platform/connectors/session'
import { votingApi } from '../../helpers/fetcher';
import {DataContext} from '../../store/GlobalState'
import { ACTIONS } from '../../store/Actions';
import { screenshot } from '@futures-platform/connectors/screenshot-service-api'

const YoutubeImageEmbed = ({ embedId, phenomenon, isTranslated, langForTransState }) => {

  const { state: {groupRadarIdGlobalState: groupRadarIdGlobalStateStore, getTheWholeCardHtmlElms}, dispatch } = useContext(DataContext)

    const cardMediaTextRef = useRef()
    const cardMediaTextRef2 = useRef()



  const [translations, settranslations] = useState(null)
  const [originalTitle, setoriginalTitle] = useState(null)

  useEffect(() => {
    const fetcher = async () => {
      const res1 = (!! cardMediaTextRef2.current || originalTitle ) && await votingApi.translation("en", langForTransState, originalTitle ?? cardMediaTextRef2.current)
      settranslations(() => {
        return {
          res1
        }
      })
     
    };
    !!isTranslated && !! originalTitle && fetcher();
    
  }, [isTranslated, originalTitle, langForTransState])

  useEffect(() => {
    if (!!phenomenon?.media?.text) {
      if (true) {
        if (!cardMediaTextRef2?.current && !!cardMediaTextRef.current?.innerHTML) {
          cardMediaTextRef2.current = cardMediaTextRef.current?.innerHTML
        }
        !!cardMediaTextRef2.current && !originalTitle && setoriginalTitle(() => cardMediaTextRef2.current)
        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD10,
        //   payload: true
        // })
      }
    }
  }, [dispatch, isTranslated, originalTitle, phenomenon?.media?.text])


const publicURL = process.env.REACT_APP_PUBLIC_URL
const isEmbedRadar = (
    !!window 
    && !!window.location 
    && !!window.location.ancestorOrigins?.length 
) ? true : false

const iframeSrc = React.useMemo(() => {
  return phenomenon?.media?.statzonChart ?? null
}, [phenomenon?.media?.statzonChart])

// switch (type) {
//   case '1':
//     iframeSrc = "https://app.statzon.com/embeds/LzRBoO5NdVpdgNDY";
//     break;
//   case '2':
//     iframeSrc = "https://app.statzon.com/embeds/GYpJ3Z5dQMXkBKgn?type=ver_line";
//     break;
//   case '3':
//     iframeSrc = "https://app.statzon.com/embeds/JnjbOrMRbMlagk7D";
//     break;
//   case '4':
//     iframeSrc = "https://app.statzon.com/embeds/dw0jl8VeRqazLRxA?type=pie";
//     break;
//   default:
//     iframeSrc = null;
// }

return (
    (phenomenon && !isEmpty(phenomenon)) ? (
        <>
            {phenomenon?.media?.video && <div className={styles.videoIframeWrapper} >
                 <iframe
                    className={styles.iframeForVideo}
                    width="853"
                    height="480"
                    src={phenomenon?.media?.video}

                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube"
                />
            </div>}
            {!isTranslated && !!phenomenon?.media?.text &&<p className={styles.mediaText} ref={cardMediaTextRef}>{phenomenon?.media?.text}</p>}
            {!!isTranslated && <p className={styles.mediaText} ref={cardMediaTextRef} dangerouslySetInnerHTML={{__html: translations?.res1?.data}}></p>}

           
            {!!phenomenon?.media?.image && <img className={styles.mediaImage} src={!isEmbedRadar ? publicURL+phenomenon?.media?.image : publicURL+phenomenon?.media?.image + `?access_token=${getSessionToken()}`} alt="nature" loading="lazy"/>}

            {iframeSrc && (
                <div className={styles.aspectRatioIframe} id="statzon-chart-container">
                    <iframe
                    className={styles.iframeForVideo}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture display-capture"
                        allowFullScreen
                        width="853"
                        height="480"
                        src={iframeSrc}
                        frameBorder="0"
                    ></iframe>
                </div>
            )}
        </>
    ) :null
);
}
export default YoutubeImageEmbed;
